import { useTranslation } from 'react-i18next';

import {
  type Organization,
  useOrganizationQuery,
} from '@innovamat/glow-api-client';

import { useUser } from '../../user-management';
import {
  isJourneysEnabled,
  isOrgAnonymized,
  isPlatformEnabled,
  isRosteringEnabled,
} from '../modules/permission/organization';

const getNextAcademicYearId = (
  currentAcademicYearId: Organization['academicYearId']
): Organization['academicYearId'] => {
  const [regionId, year] = currentAcademicYearId.split('_');
  const nextAcademicYearId = `${regionId}_${Number(year) + 1}`;
  return nextAcademicYearId;
};

function useOrganization() {
  const { t } = useTranslation();
  const { user } = useUser();
  const { data: { organization } = {}, isLoading } = useOrganizationQuery<{
    organization: Organization;
  }>(
    { id: user?.organizationId! },
    { enabled: !!user?.organizationId, staleTime: Infinity }
  );

  const mapTranslation = (lang: string | null) => ({
    value: lang!,
    label: t(`common.language.${lang}`),
  });

  const availableLanguages =
    organization?.availableLanguages?.map(mapTranslation);

  return {
    availableLanguages,
    isJourneysEnabled: isJourneysEnabled(organization),
    isOrgAnonymized: isOrgAnonymized(organization),
    isPlatformEnabled: isPlatformEnabled(organization),
    isRosteringEnabled: isRosteringEnabled(organization),
    loading: isLoading,
    organization,
  };
}

export { getNextAcademicYearId, useOrganization };
